import {
  type AssociationMappingsProps,
  toExtendedOption,
} from "@hightouch/formkit";
import { AssociationMappings as AssociationMappingsV2 } from "src/formkit/components/mapper-v2/association-mappings";
import type { SharedProps } from ".";

export const FKAssociationMappings = ({
  name,
  options,
  error,
  excludeMappings,
  ascOptions,
  isDisabled,
  query,
}: AssociationMappingsProps & SharedProps) => (
  <AssociationMappingsV2
    ascOptions={toExtendedOption(ascOptions)}
    error={error}
    excludeMappings={excludeMappings}
    isDisabled={isDisabled}
    loading={query.isFetching}
    name={name}
    options={toExtendedOption(query.enabled ? query.data : options)}
    reload={query.refetch}
  />
);
